import Modal from "~components/Modal";
import { WarningIcon } from "~misc/icons";
import PropTypes from "prop-types";

const PriceSearchClientShareModal = ({
  isOpen,
  setIsOpen,
  gruposProdutoVotorantim,
  gruposProdutoConcorrencia,
  handleConfirm,
}) => {
  const handleYes = (e) => {
    setIsOpen(false);
    handleConfirm(e);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      sub={
        <Content
          gruposProdutoVotorantim={gruposProdutoVotorantim}
          gruposProdutoConcorrencia={gruposProdutoConcorrencia}
        />
      }
      buttonOne={"Sim"}
      buttonTwo={"Não"}
      onClose={handleCancel}
      linkOne={handleYes}
      linkTwo={handleCancel}
      className="price-search-client-share-modal"
    />
  );
};

PriceSearchClientShareModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  gruposProdutoVotorantim: PropTypes.arrayOf(PropTypes.string),
  gruposProdutoConcorrencia: PropTypes.arrayOf(PropTypes.string),
  handleConfirm: PropTypes.func.isRequired,
};

const Content = ({ gruposProdutoVotorantim, gruposProdutoConcorrencia }) => {
  return (
    <div className="content">
      <h3 className="title">
        <WarningIcon fill="red" width={30} height={30} />
        Aviso!
      </h3>

      {gruposProdutoVotorantim?.length > 0 && (
        <>
          <p className="desc">
            Esse cliente só possui pesquisas da VOTORANTIM (clientshare = 100%) para os seguintes produtos:
          </p>

          <div className="tag">
            {gruposProdutoVotorantim?.map((grupo) => (
              <>
                {grupo} <br />
              </>
            ))}
          </div>
        </>
      )}

      {gruposProdutoConcorrencia?.length > 0 && (
        <>
          <p className="desc">
            Esse cliente só possui pesquisas da concorrência (clientshare = 100%) para os seguintes produtos:
          </p>

          <div className="tag">
            {gruposProdutoConcorrencia?.map((grupo) => (
              <>
                {grupo} <br />
              </>
            ))}
          </div>
        </>
      )}

      <p className="desc">Confirma a informação?</p>
    </div>
  );
};

Content.propTypes = {
  gruposProdutoVotorantim: PropTypes.arrayOf(PropTypes.string),
  gruposProdutoConcorrencia: PropTypes.arrayOf(PropTypes.string),
};

PriceSearchClientShareModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  gruposProdutoVotorantim: PropTypes.arrayOf(PropTypes.string),
  gruposProdutoConcorrencia: PropTypes.arrayOf(PropTypes.string),
  handleConfirm: PropTypes.func.isRequired,
};

export default PriceSearchClientShareModal;
